import { createRouter, createWebHistory } from "@ionic/vue-router";
import {
	RouteRecordRaw,
	RouteLocationNormalized,
	NavigationGuardNext,
} from "vue-router";

import authApp from "@/libs/auth";
//import { useCustomerStore } from "@/stores/customer";

import httpApp from "@/libs/http";
import settingsApp from "@/libs/settings";
import { useLocalStorage } from "@/libs/localStorage";
const { getLocalStorageData, setLocalStorageData } = useLocalStorage();

import NotFound from "../views/NotFound.vue";

const accountGuard = async (
	to: RouteLocationNormalized,
	from: RouteLocationNormalized,
	next: NavigationGuardNext
) => {
	try {
		const isLoggedIn = await authApp.isloggedIn(false, true);
		if (isLoggedIn) {
			next();
		} else {
			const referralUrl = to.path;
			setLocalStorageData({ referralUrl: referralUrl });
			next("/account/login");
		}
	} catch (error) {
		console.log(error);
		const referralUrl = to.path;
		setLocalStorageData({ referralUrl: referralUrl });
		next("/account/login");
	}
};

const authGuard = async (
	to: RouteLocationNormalized,
	from: RouteLocationNormalized,
	next: NavigationGuardNext
) => {
	try {
		const isLoggedIn = await authApp.isloggedIn(false, true);
		if (isLoggedIn) {
			next("/account");
		} else {
			next();
		}
	} catch (error) {
		next();
	}
};

const cookGuard = async (
	to: RouteLocationNormalized,
	from: RouteLocationNormalized,
	next: NavigationGuardNext
) => {
	//const customerStore = useCustomerStore();
	try {
		const sellerData = getLocalStorageData("sellerData");
		if (sellerData) {
			if (!sellerData?.is_vendor || !sellerData?.is_approved) {
				if (to.path == "/cook/account") {
					next("/cook/account/setting");
				} else {
					next();
				}
			} else {
				next();
			}
		} else {
			next("/apply-as-vendor");
		}
	} catch (error) {
		next();
	}
};

const routes: Array<RouteRecordRaw> = [
	{
		path: "/index.html",
		redirect: "/",
	},
	{
		path: "/home",
		redirect: "/",
	},
	{
		path: "/",
		name: "Home",
		component: () => import("../views/HomePage.vue"),
	},
	{
		path: "/account/login",
		name: "login",
		component: () => import("../views/account/Login.vue"),
		beforeEnter: authGuard,
		meta: {
			title: "Account Login",
		},
	},
	{
		path: "/account/signup",
		name: "signup",
		component: () => import("../views/account/Register.vue"),
		beforeEnter: authGuard,
		meta: {
			title: "Account Sign Up",
		},
	},
	{
		path: "/account/resetpassword",
		name: "resetpassword",
		component: () => import("../views/account/ResetPassword.vue"),
		beforeEnter: authGuard,
		meta: {
			title: "Reset Password",
		},
	},
	{
		path: "/account/confirm",
		name: "confirm",
		component: () => import("../views/account/Confirm.vue"),
		beforeEnter: authGuard,
		meta: {
			title: "Account Login",
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/account",
		name: "AccountDetails",
		component: () => import("../views/account/AccountDetails.vue"),
		beforeEnter: accountGuard,
		meta: {
			title: "Account Details",
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/account/orders",
		name: "AccountOrders",
		component: () => import("../views/account/Orders.vue"),
		beforeEnter: accountGuard,
		meta: {
			title: "Orders",
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/account/order/:orderNo",
		name: "Account Order",
		component: () => import("../views/account/Order.vue"),
		beforeEnter: cookGuard,
		meta: {
			title: "Account Order",
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/account/following",
		name: "AccountFollowing",
		component: () => import("../views/account/Following.vue"),
		beforeEnter: accountGuard,
		meta: {
			title: "Following",
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/account/rewards",
		name: "AccountRewards",
		component: () => import("../views/account/Rewards.vue"),
		beforeEnter: accountGuard,
		meta: {
			title: "Rewards",
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/account/vouchers",
		name: "AccountVouchersAndCredits",
		component: () => import("../views/account/VouchersAndCredits.vue"),
		beforeEnter: accountGuard,
		meta: {
			title: "VouchersAndCredits",
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/account/faq",
		name: "AccountFaq",
		component: () => import("../views/account/FAQ.vue"),
		beforeEnter: accountGuard,
		meta: {
			title: "FAQ",
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/apply-as-vendor",
		name: "BecomeACook",
		component: () => import("../views/cook/BecomeACook.vue"),
		meta: {
			title: "Apply To Cook",
		},
	},
	{
		path: "/account/messages",
		name: "Messages",
		component: () => import("../views/Messages.vue"),
		beforeEnter: accountGuard,
		meta: {
			title: "Messages",
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/cook/account",
		name: "CookProfile",
		component: () => import("../views/cook/CookProfile.vue"),
		beforeEnter: cookGuard,
		meta: {
			title: "Cook Profile",
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/cook/account/setting",
		name: "Account Setting",
		component: () => import("../views/cook/CookAccountSettings.vue"),
		beforeEnter: cookGuard,
		meta: {
			title: "Account Setting",
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/cook/account/orders",
		name: "Account Orders",
		component: () => import("../views/cook/Orders.vue"),
		beforeEnter: cookGuard,
		meta: {
			title: "Account Orders",
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/cook/account/training",
		name: "Account Main Training Material",
		component: () => import("../views/cook/TrainingMaterial.vue"),
		beforeEnter: cookGuard,
		meta: {
			title: "Account Main Training Material",
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/cook/account/training/:identifier",
		name: "Account Training Material",
		component: () => import("../views/cook/TrainingContentPage.vue"),
		beforeEnter: cookGuard,
		meta: {
			title: "Account Training Material",
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/cook/account/help",
		name: "Account Main Help",
		component: () => import("../views/cook/Help.vue"),
		beforeEnter: cookGuard,
		meta: {
			title: "Account Main Help",
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/cook/account/help/:identifier",
		name: "Account Help Content",
		component: () => import("../views/cook/HelpContentPage.vue"),
		beforeEnter: cookGuard,
		meta: {
			title: "Account Help Content",
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/cook/account/help/qa",
		name: "Account Help Q&A",
		component: () => import("../views/cook/HelpQAndAPage.vue"),
		beforeEnter: cookGuard,
		meta: {
			title: "Account Help Q&A",
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/cook/account/insights",
		name: "Account Insights",
		component: () => import("../views/cook/Insights.vue"),
		beforeEnter: cookGuard,
		meta: {
			title: "Account Insights",
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/cook/account/payment",
		name: "Account Payment Details",
		component: () => import("../views/cook/PaymentDetails.vue"),
		beforeEnter: cookGuard,
		meta: {
			title: "Account Payment Details",
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/cooks/list/:postcode",
		name: "Cooks List",
		component: () => import("../views/CooksList.vue"),
		meta: {
			title: "Cooks List",
		},
	},
	{
		path: "/cooks/list/all/:postcode/:regionalFood/:date",
		name: "Cooks List All with regional food",
		component: () => import("../views/CooksListAll.vue"),
		meta: {
			title: "Cooks List",
			sitemap: { ignoreRoute: true },
		},
	},
	// {
	// 	path: "/cooks/list/all/:postcode",
	// 	name: " List All Cooks",
	// 	component: () => import("../views/ListAllCooks.vue"),
	// 	meta: {
	// 		title: "List All Cooks",
	// 	},
	// },
	{
		path: "/cooks/list/day/:postcode/:date",
		name: "Cooks List Day",
		component: () => import("../views/CooksListDate.vue"),
		meta: {
			title: "Cooks List",
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/cooks/list/all/popular-dishes",
		name: "Popular Dishes",
		component: () => import("../views/PopularDishes.vue"),
		meta: {
			title: "Popular Dishes",
		},
	},
	{
		path: "/cooks/coming-soon/:postcode",
		name: "Cooks List All",
		component: () => import("../views/CooksComingSoon.vue"),
		meta: {
			title: "Cooks List",
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/cooks/cookProfile/:cook_code",
		name: "Cook Profile",
		component: () => import("../views/CookProfile.vue"),
		meta: {
			title: "Cook Profile",
		},
	},
	{
		path: "/cooks/share/:cook_code",
		name: "Cook Share",
		component: () => import("../views/Share.vue"),
		meta: {
			title: "Cook Share",
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/:catchAll(.*)",
		name: "invalid",
		components: {
			default: NotFound,
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/checkout",
		name: "checkout",
		component: () => import("../views/Checkout.vue"),
		beforeEnter: accountGuard,
		meta: {
			title: "Checkout",
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/checkout/payment-success",
		name: "checkoutPaymentSuccess",
		component: () => import("../views/CheckoutPaymentSuccess.vue"),
		meta: {
			title: "Checkout",
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/checkout/payment-cancel",
		name: "checkoutPaymentCancel",
		component: () => import("../views/CheckoutPaymentCancel.vue"),
		meta: {
			title: "Checkout",
			sitemap: { ignoreRoute: true },
		},
	},
	{
		path: "/cart",
		name: "cart",
		component: () => import("../views/Cart.vue"),
		meta: {
			title: "Cart",
		},
	},
	{
		path: "/platters-listing/:postcode",
		name: "Platters Listing",
		component: () => import("../views/PlattersListing.vue"),
		meta: {
			title: "Platters Listing",
		},
	},
	{
		path: "/platters-cooks-order/:cooksCodes/:selectedDate",
		name: "PlattersCooksOrder",
		component: () => import("../views/PlattersCooksOrder.vue"),
		meta: {
			title: "PlattersCooksOrder",
		},
	},
	{
		path: "/our-mission",
		name: "OurMission",
		component: () => import("../views/OurMission.vue"),
		meta: {
			title: "Our Mission",
		},
	},
	{
		path: "/curation-and-quality",
		name: "FoodSafety",
		component: () => import("../views/FoodSafety.vue"),
		meta: {
			title: "Curation & Quality",
		},
	},
	{
		path: "/faq",
		name: "FAQ",
		component: () => import("../views/FAQS.vue"),
		meta: {
			title: "FAQ",
		},
	},
	{
		path: "/contact-us",
		name: "Contact Us",
		component: () => import("../views/ContactUs.vue"),
		meta: {
			title: "Contact Us",
		},
	},
	{
		path: "/blog/",
		name: "Blog",
		component: () => import("../views/blog/Blog.vue"),
		meta: {
			title: "Blog",
		},
	},
	{
		path: "/blog/post/:url_path",
		name: "Blog Post",
		component: () => import("../views/blog/BlogPost.vue"),
		meta: {
			title: "Blog Post",
		},
	},
	{
		path: "/blog/category/:url_path",
		name: "Blog Category",
		component: () => import("../views/blog/BlogCategory.vue"),
		meta: {
			title: "Blog Category",
		},
	},
	{
		path: "/blog/tag/:tag_name",
		name: "Blog Tag",
		component: () => import("../views/blog/BlogTag.vue"),
		meta: {
			title: "Blog Tag",
		},
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	scrollBehavior() {
		return new Promise((resolve) => {
			setTimeout(() => {
				const element = document.querySelector(
					"#mainHeader"
				) as HTMLElement;
				if (element) {
					element.scrollIntoView({
						block: "start",
						inline: "start",
					});
				}
				resolve({ left: 0, top: 0 });
			}, 500);
		});
	},
});

router.beforeEach(async (to, from, next) => {
	if (to.params["catchAll"]) {
		const request_path = to.params["catchAll"];
		const navPath = "/" + request_path;

		try {
			const response = (await httpApp.sendPostRequest(
				settingsApp.getEndpointUrl("parseUrlKey"),
				{
					request_path: request_path,
					store_view: "en",
				}
			)) as any;

			if (response.success) {
				let newRoute;
				if (response.data.object_type == "product") {
					// newRoute = {
					// 	path: navPath,
					// 	name: request_path,
					// 	component: () => import("../views/Product.vue"),
					// 	props: {
					// 		product_id: response.data.object_id,
					// 	},
					// } as RouteRecordRaw;
				} else if (response.data.object_type == "category") {
					// newRoute = {
					// 	path: navPath,
					// 	name: request_path,
					// 	component: () => import("../views/Category.vue"),
					// 	props: {
					// 		category_id: response.data.object_id,
					// 	},
					// } as RouteRecordRaw;
				} else if (response.data.object_type == "cms_page") {
					newRoute = {
						path: navPath,
						name: request_path,
						component: () => import("../views/CMSPage.vue"),
						props: {
							pageId: response.data.object_id,
							pageIdentifier: request_path,
						},
					} as RouteRecordRaw;
				}
				router.addRoute(newRoute);
				next(navPath);
				return;
			} else {
				const newRoute = {
					path: navPath,
					name: request_path,
					component: NotFound,
				} as RouteRecordRaw;
				router.addRoute(newRoute);
				next(navPath);
				return;
			}
		} catch (error) {
			next();
			return;
		}
	} else {
		next();
		return;
	}
});

export default router;
